import { getDybrArchive } from '@/api/profiles';
import { ActionButton } from '@/components/Shared/Buttons';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import fileDownload from 'js-file-download';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export function ArchiveDownload() {
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [token] = useTokenState();
  const { activeProfileId } = useActiveProfile();
  const profileId = useSelector(
    state => selectActiveProfileAugmented(state, { activeProfileId }).id
  );

  async function getArchive(profileId) {
    setLoading(true);
    setStartTime(Date.now());
    const data = await getDybrArchive({ profileId, token });
    if (!data.error) {
      const filename = 'dybr_blog_' + profileId + '.zip';
      fileDownload(data, filename);
    } else {
      window.alert(
        'Проблема при загрузке, попробуйте еще раз или обратитесь к администрации'
      );
    }
    setLoading(false);
  }

  const waitingTime = startTime && (Date.now() - startTime) / 1000;

  return (
    <>
      <p>Вы можете скачать архив своего блога в формате json:</p>
      {loading && waitingTime > 1 ? (
        <p>
          <strong>Архив создается, не закрывайте страницу</strong>
        </p>
      ) : (
        <p> </p>
      )}
      <ActionButton
        onClick={() => {
          getArchive(profileId);
        }}
        disabled={loading}
      >
        Скачать архив
      </ActionButton>
    </>
  );
}
